// @see https://github.com/AS3Commons/as3commons-collections/blob/master/src/org/as3commons/collections/Map.as

interface Map<K, V> {
  toArray(): V[];
  add(key: K, value: V): boolean;
  hasKey(key: K): boolean;
}

{
  // `Map.values()` returns an empty iterator on PhantomJS/2.1.1
  // Might be due to a bug in the `es6-shim` implementation, but didn't
  // investigate further.
	// Regardless, if the iterator is faulty then we install a polyfill/patch
  const map = new Map<string, number>([
    ['a', 1],
    ['b', 2],
    ['c', 3],
  ]);
  const values = Array.from(map.values());
  if (values.length != 3 ||  values[0] != 1 || values[1] != 2 || values[2] != 3) {
    Map.prototype.values = function() {
      const result: any[] = [];
      this.forEach(function(value: any) {
        result.push(value);
      });
      return result.values();
    }
  }
}

Object.assign(Map.prototype, {
  toArray: function(this: Map<any, any>) {
    return Array.from(this.values());
  },

  hasKey: function(this: Map<any, any>, key: any) {
    return this.has(key);
  },

  add: function(this: Map<any, any>, key: any, value: any) {
    this.set(key, value);
    return true;
  }
});
